// Linkify çekirdeği + mention/hashtag eklentileri — ESM/CJS güvenli yükleyici

type AnyMod = any;

async function tryImport(
  candidates: string[],
): Promise<{ mod: AnyMod; path: string } | null> {
  for (const spec of candidates) {
    try {
      const mod = await import(/* @vite-ignore */ spec);
      return { mod, path: spec };
    } catch {}
  }
  return null;
}

/* — statik fallback’ler (namespace import) — */
import * as linkifyBase from "linkifyjs";
import * as mentionStatic from "linkify-plugin-mention";
import * as hashtagStatic from "linkify-plugin-hashtag";

function pickPluginFn(mod: AnyMod): ((l: any) => void) | null {
  const f =
    mod?.default ??
    mod?.hashtag ??
    mod?.mention ??
    Object.values(mod || {}).find((v: any) => typeof v === "function");
  return typeof f === "function" ? (f as any) : null;
}

export const linkifyInitPromise = (async () => {
  try {
    // çekirdek
    const coreDyn =
      (await tryImport([
        "linkifyjs",
        "linkifyjs/index.js",
        "linkifyjs/index.es.js",
        "linkifyjs/dist/linkify.es.js",
        "linkifyjs/dist/linkify.js",
      ])) ?? { mod: linkifyBase, path: "static:fallback(linkifyjs)" };

    const linkify = (coreDyn.mod?.default ?? coreDyn.mod) as any;
    if (!linkify) {
      console.warn("Linkify init: çekirdek yüklenemedi.");
      return;
    }

    // mention
    const mentionDyn = await tryImport([
      "linkifyjs/plugins/mention",
      "linkifyjs/plugins/mention/index.js",
      "linkifyjs/plugins/mention/mention.js",
      "linkify-plugin-mention",
      "linkify-plugin-mention/index.js",
    ]);
    const mentionFnDyn = pickPluginFn(mentionDyn?.mod);
    const mentionFnSta = pickPluginFn(mentionStatic);
    const mentionFn = mentionFnDyn ?? mentionFnSta;
    if (mentionFn) mentionFn(linkify);

    // hashtag
    const hashtagDyn = await tryImport([
      "linkifyjs/plugins/hashtag",
      "linkifyjs/plugins/hashtag/index.js",
      "linkifyjs/plugins/hashtag/hashtag.js",
      "linkify-plugin-hashtag",
      "linkify-plugin-hashtag/index.js",
    ]);
    const hashtagFnDyn = pickPluginFn(hashtagDyn?.mod);
    const hashtagFnSta = pickPluginFn(hashtagStatic);
    const hashtagFn = hashtagFnDyn ?? hashtagFnSta;
    if (hashtagFn) hashtagFn(linkify);

    // Linkify başarıyla yüklendi (sessiz)
  } catch (e) {
    console.warn("Linkify init hata:", e);
  }
})();
